import Vue from 'vue'

import types from '../types'
import {Current} from '../../interface'

const initialState: Current = {
  x: 0,
  y: 0,
  rotate: 0,
  scale: 1,
  file: null,
  shape: -1,
  number: 0,
  isNew: true,
  isChangeImage: false,
  image_width: 0,
  image_height: 0
}

const state: Current = {
  x: 0,
  y: 0,
  rotate: 0,
  scale: 1,
  file: null,
  shape: -1,
  number: 0,
  isNew: true,
  isChangeImage: false,
  image_width: 0,
  image_height: 0
}

const getters = {
}

const actions = {
}

const mutations = {
  [types.mutations.CURRENT_INIT](state: any): void {
    initialState.shape = state.shape
    Object.assign(state, initialState)
  },
  [types.mutations.CURRENT_INIT_ALL](state: any): void {
    initialState.shape = -1
    Object.assign(state, initialState)
  },
  [types.mutations.CURRENT_UPDATE](state: any, update: Current): void {
    update.isChangeImage = false
    Object.assign(state, update)
  },
  [types.mutations.CURRENT_FILE](state: any, file: string): void {
    Vue.set(state, 'isChangeImage', true)
    Vue.set(state, 'file', file)
  },
  [types.mutations.CURRENT_ROTATE](state: any, rotate: number): void {
    while (rotate > 360) {
        rotate -= 360
    }
    while (rotate < 0) {
        rotate += 360
    }

    rotate = Math.round(rotate * 100) / 100
    Vue.set(state, 'rotate', rotate)
  },
  [types.mutations.CURRENT_SCALE](state: any, scale: number): void {
    if (scale > 10) {
        scale = 10
    }
    if (scale < 0.1) {
        scale = 0.1
    }

    scale = Math.round(scale * 100) / 100
    Vue.set(state, 'scale', scale)
  },
  [types.mutations.CURRENT_SHAPE](state: any, shape: string): void {
    Vue.set(state, 'shape', shape)
  },
  [types.mutations.CURRENT_X](state: any, x: number): void {
    Vue.set(state, 'x', x)
  },
  [types.mutations.CURRENT_Y](state: any, y: number): void {
    Vue.set(state, 'y', y)
  },
  [types.mutations.CURRENT_NUMBER](state: any, num: number): void {
    Vue.set(state, 'number', num)
  },
  [types.mutations.CURRENT_IMAGE_WIDTH](state: any, width: number): void {
    Vue.set(state, 'image_width', width)
  },
  [types.mutations.CURRENT_IMAGE_HEIGHT](state: any, height: number): void {
    Vue.set(state, 'image_height', height)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
